import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataAnalyticsRoutingModule } from './data-analytics-routing.module';
import { DataAnalyticsComponent } from './data-analytics.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DaHeaderComponent } from './components/da-header/da-header.component';
import { DaTrendsComponent } from './components/da-trends/da-trends.component';
import { DaCostContributionsComponent } from './components/da-cost-contributions/da-cost-contributions.component';
import { DaFactorySummaryComponent } from './components/da-factory-summary/da-factory-summary.component';
import { DaRmPmComponent } from './components/da-rm-pm/da-rm-pm.component';
import { DaVolumeComponent } from './components/da-volume/da-volume.component';
import { FactorySelectionModalComponent } from './components/factory-selection-modal/factory-selection-modal.component';
import { ViewMoreComponent } from './components/da-cost-contributions/view-more/view-more.component';
import { NguCarouselModule } from '@ngu/carousel';
import { DaChartPopupComponent } from './components/da-chart-popup/da-chart-popup.component';
// import { CostPipe } from './pipes/cost.pipe';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { BarLineComboChartComponent } from './components/bar-line-combo-chart/bar-line-combo-chart.component';

import { DaVolumePopupViewComponent } from './components/da-volume-popup-view/da-volume-popup-view.component';
import { DaRmPmPopupViewComponent } from './components/da-rm-pm-popup-view/da-rm-pm-popup-view.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SaveTagPopupComponent } from './components/save-tag-popup/save-tag-popup.component';
import { BarChartPopupComponent } from './components/bar-chart/bar-chart-popup/bar-chart-popup.component';
import { QuillModule } from 'ngx-quill';

import { BarLineComboChartPopupComponent } from './components/bar-line-combo-chart/bar-line-combo-chart-popup/combo-chart-popup.component';
import { OeeAndChangeOverComponent } from './components/oee-and-change-over/oee-and-change-over.component';
import { OeeAndChangeOverPopupComponent } from './components/oee-and-change-over/oee-and-change-over-popup/oee-over-popup.component';
import { ChangeOverPopupComponent } from './components/oee-and-change-over/change-over-popup/change-over-popup.component';
import { FlexLayoutModule } from '@angular/flex-layout';
@NgModule({
    declarations: [
        DataAnalyticsComponent,
        DaHeaderComponent,
        DaTrendsComponent,
        DaCostContributionsComponent,
        DaFactorySummaryComponent,
        DaRmPmComponent,
        DaVolumeComponent,
        FactorySelectionModalComponent,
        DaChartPopupComponent,
        ViewMoreComponent,
        SaveTagPopupComponent,
        BarChartComponent,
        BarLineComboChartComponent,
        DaVolumePopupViewComponent,
        DaRmPmPopupViewComponent,
        BarChartPopupComponent,
        BarLineComboChartPopupComponent,
        OeeAndChangeOverComponent,
        OeeAndChangeOverPopupComponent,
        ChangeOverPopupComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        DataAnalyticsRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        NguCarouselModule,
        MatButtonModule,
        MatTooltipModule,
        FormsModule,
        QuillModule.forRoot(),
        FlexLayoutModule
    ]
})
export class DataAnalyticsModule { }
